import {Component, OnInit} from '@angular/core';
import {BmCustomerBillingTransactionTypeBaseComponent} from '../bm-customer-billing-transaction-type-base.component';


@Component({
    selector: 'bm-customer-billing-transaction-type-side',
    templateUrl: 'bm-customer-billing-transaction-type-side.component.html',
    standalone: false
})
export class BmCustomerBillingTransactionTypeSideComponent extends BmCustomerBillingTransactionTypeBaseComponent implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }

}
